export default class cookieManagerValidated {
  #affKey;
  #queryArg;

  constructor(key, qArg) {
    this.#affKey = key;
    this.#queryArg = qArg;

    // detect query Arg if provided
    const url = new URL(window.location.href);
    // Checks if a value exists in the search params (boolean)
    if (url.searchParams.has(this.#queryArg)) {
      if ("erase" == url.searchParams.get(this.#queryArg)) {
        this.#forget();
      } else {
        this.#lookup(url.searchParams.get(this.#queryArg));
      }
    }
  }

  #lookup(code) {
    // Create a new array from the wizard array
    var foundIt = rentalzAffTracking.affiliates.filter(function (affiliate) {
      // Only include wizards from the Gryfindor house
      return affiliate.code === code;
    });

    if (foundIt.length) {
      this.#remember(foundIt[0]);
    }
    return false;

    const url = new URL(rentalzAffTracking.ajaxURI);
    url.searchParams.append("action", rentalzAffTracking.action);
    url.searchParams.append("_ajax_nonce", rentalzAffTracking.nonce);
    url.searchParams.append("affiliate", code);
    //https://ricard.dev/how-to-use-wordpress-admin-ajax-with-fetch-api/

    fetch(url, {
      method: "POST",
      body: "",
      credential: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((responseJSON) => {
        this.#remember(responseJSON.data);
      })
      .catch((error) => {
        console.log("response failed", error);
        return false;
      });
  }
  /**
   *
   * @param {*} code string/object - could either a irclickid code or a object with code and phoneNumber
   */
  #remember(code) {
    // Store data
    console.log("remember", code);
    localStorage.setItem(this.#affKey, JSON.stringify(code));
  }

  recall() {
    // retrieve code from local storage
    let stored = localStorage.getItem(this.#affKey);
    console.log("recall", stored);
    return null === stored ? false : JSON.parse(stored);
  }

  #forget() {
    localStorage.removeItem(this.#affKey);
  }
}
